<template>
  <div class="sysn width1200">
    <div class="item">
      <p class="title">超级HTTP代理隧道接入服务器：</p>
      <div class="content">
        <p class="text1">域名:端口，类似以下形式：</p>
        <p class="text2">
          http-proxy.dobel.cn:9180
          （注意，不一定是这个，具体的视实际分配的而定）
        </p>
      </div>
    </div>

    <div class="item">
      <p class="title">验证方式：</p>
      <div class="content">
        <p class="text2">支持账密</p>
        <p class="text2">支持IP白名单</p>
      </div>
    </div>

    <div class="item">
      <p class="title">HTTP验证方式原理说明：</p>
      <div class="content">
        <p class="text2">平台会对每个代理请求进行验证，验证的原理如下：</p>
        <p class="text2">
          在请求的header里面添加Proxy-Authorization参数(账户名:密码)来进行账号校验，账号名和密码会在购买后分配给您。Proxy-Authorization的具体格式：
        </p>
        <p class="text2">
          Proxy-Authorization: &lt;type&gt;&lt;credentials&gt;
        </p>
        <p class="text1">说明：</p>
        <p class="text2">
          &lt;type&gt;：身份验证类型（这里为Basic）<br />&lt;credentials&gt;：凭证信息，凭证的构成方式如下：<br />将账号名和密码用冒号拼接（user:password）
        </p>
        <p class="text2">
          将拼接生成的字符串使用 base64
          编码方式进行编码（YWxhZGRpbjpvcGVuc2VzYW1l）
        </p>
        <p class="text1">
          正确设置后，发出的请求都将包含如下格式的HTTP header信息：
        </p>
        <p class="text2">Proxy-Authorization: Basic YWxhZGRpbjpvcGVuc2VzYW1l</p>
        <p class="text1">
          注意：主流编程语言或者框架大部分都默认支持直接设置代理的账号名和密码信息，无需通过上面手动的方式设置Proxy-Authorization请求头，特别是访问https网站时不要手动设置Proxy-Authorization请求头，详情请参考示例代码。
        </p>
      </div>
    </div>

    <div class="item">
      <p class="title">使用方法：</p>
      <div class="content">
        <p class="text2">
          1.
          注册多贝云平台账号，登录Portal系统，在“超级HTTP隧道”产品页面购买，付款完成之后即可在列表页面看到新开通的用户名、密码以及服务器地址、端口等信息
        </p>
        <p class="text2">
          2.
          将新购买的代理服务器地址、端口以及用户名、密码等配置信息配置到项目或者程序的全局代理设置中，这样即可使用到多贝云平台的动态IP服务
        </p>
      </div>
    </div>

    <div class="item">
      <p class="title">使用方式：</p>
      <div class="content">
        <p class="text2">
          用户无需API提取，购买产品后生成固定的隧道地址、端口以及对应的账密。购买时可选相应的通道数（同时在线的代理IP数）、并发数（账号总的并发数）、总带宽（账号总的可用带宽bps）
        </p>
        <p class="text3">
          可用参数：<br>
          user：账号 <br>
          password：密码 <br>
          region：地区编码（6位）如：广州440100，广东全省440000，全国any <br>
          sessionID：当前请求的通道名称区间值[1-99999]，不传默认为0，占一个通道数每次请求都重新分配代理IP <br>
          sessiontime：当前通道的可用时长区间值[1-30]分钟，必须配合sessionID使用 <br>
          only：是否去重，默认不去重[0:不去重（默认），1：强制去重无新IP直接失败，2：优先去重]，去重周期24小时当天0点-24点 <br>
        </p>
        <p class="text2">
          curl示例：<br>
          curl -x user-账号-region-any-sessionID-3-sessiontime-2:密码@xxx.dobel.cn:10000 xxx.xxx.com <br>
          curl -x user-账号-region-440000:密码@xxx.dobel.cn:10000 xxx.xxx.com <br>
          curl -x user-账号-region-440000-sessionID-3-sessiontime-2:密码@xxx.dobel.cn:10000 xxx.xxx.com <br>
          curl -x user-账号-region-any-sessionID-3-sessiontime-2-only-1:密码@xxx.dobel.cn:10000 xxx.xxx.com <br>
        </p>
      </div>
    </div>

    <div class="item">
      <p class="title">API使用说明：</p>
      <div class="content">

        <p class="text1">切换IP接口：</p>
        <p class="text2">
          只有指定sessionID才生效，每秒只能调用1次，sessiontime要大于30秒 <br>
          提供两种方式：<br>
          curl -x xxxx://user-xxxx-region-xxx-sessionID-3-sessiontime-2-switch:xxx@xxx.xxx.xxx.xxx:xxxx  目标地址<br>
          curl -x http://user-xxxx-region-xxx-sessionID-3-sessiontime-2:xxx@xxx.xxx.xxx.xxx:xxxx  http://ip.dobel.cn/switchip<br>
        </p>

        <p class="text1">查询当前IP接口：</p>
        <p class="text2">
          GET http://proxy-api.dobel.cn:8003/currentip?account=xxxxx&accountkey=xxxxx <br>
          通过接口调用，返回当前账号下的所有对应关系
          <json-viewer
              class="jsonview"
              :value="jsonData"
              :expand-depth="10"
              :copyable="true"
          >
          </json-viewer>
        </p>

      </div>
    </div>
  </div>
</template>

<script>
import JsonViewer from "vue-json-viewer"

export default {
  data() {
    return {
      jsonData: {
        code: 200,
        data: [{
          session_id: 1,
          session_time: 1,
          province: "xx",
          city: "xx",
          wan_ip: "x.x.x.x",
          isp: "xx",
          expired_at: "2025-05-01 00:00:00"
        }],
        msg: "success"
      }
    }
  },
  components: {
    JsonViewer,
  },
}
</script>

<style lang="less" scoped>
.sysn {
  padding-top: 50px;
  .item {
    margin-bottom: 68px;
    color: #000;
    .title {
      font-size: 20px;
      font-weight: bold;
    }
    .content {
      background: #f2f9f4;
      padding: 22px;
      p {
        margin-bottom: 8px;
        &.text1 {
          font-size: 18px;
          font-weight: bold;
        }
        &.text2 {
          font-size: 17px;
        }
        &.text3 {
          font-size: 18px;
          color: #ff0000;
        }
      }
      img {
        margin-top: 10px;
        &.github {
          margin-left: 10px;
          margin-top: 0;
        }
      }
    }
  }
}
@media (max-width: 1024px) {
  .sysn .item .content img {
    width: 100%;
  }
  .sysn .item .content img.github {
    width: 80px;
  }
}
@media (max-width: 768px) {
  .sysn {
    padding: 4% 0;
  }
  .sysn .item {
    margin-bottom: 2%;
  }
  .sysn .item .title {
    font-size: 16px;
  }
  .sysn .item .content {
    padding: 2%;
  }
  .sysn .item .content p.text1,
  .sysn .item .content p.text3 {
    font-size: 15px;
  }
  .sysn .item .content p.text2 {
    font-size: 14px;
  }
}
</style>